import type { Registry } from './registry';

interface RpcInvocation { payload: string; }
interface RpcCapableParticipant {
  registerRpcMethod(method: string, handler: (data: RpcInvocation) => Promise<string>): void;
}

export function registerCallSiteFunctionHandler(
  localParticipant: RpcCapableParticipant,
  registry: Registry,
): void {
  localParticipant.registerRpcMethod('callSiteFunction', async (data) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let parsed: { name?: string; args?: any };
    try {
      parsed = JSON.parse(data.payload);
    } catch {
      return JSON.stringify({ success: false, error: 'invalid payload JSON' });
    }
    if (!parsed.name) {
      return JSON.stringify({ success: false, error: 'missing function name' });
    }
    try {
      const result = await registry.invokeSiteFunction(parsed.name, parsed.args ?? {});
      return JSON.stringify({ success: true, result });
    } catch (e) {
      return JSON.stringify({ success: false, error: String((e as Error).message ?? e) });
    }
  });
}
